module.exports = __webpack_public_path__ + "img/download-1-INTAPP.d1c04174.png";